import { verticalAlignPlugin } from './plugin'

export const initVerticalAlignPlugin = () => {
  if (CKEDITOR.plugins.get('verticalalign')) {
    return
  }

  CKEDITOR.plugins.add('verticalalign', verticalAlignPlugin)
}
